/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_Intensity_GroupInputs */

const en_us2_profile_editors_pain_intensity_group = /** @type {(inputs: Profile_Editors_Pain_Intensity_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How much it hurts, 1 to 10`)
};

const pt_br2_profile_editors_pain_intensity_group = /** @type {(inputs: Profile_Editors_Pain_Intensity_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto dói, de 1 a 10`)
};

const es_419_profile_editors_pain_intensity_group = /** @type {(inputs: Profile_Editors_Pain_Intensity_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuánto duele, del 1 al 10`)
};

const pt_pt2_profile_editors_pain_intensity_group = /** @type {(inputs: Profile_Editors_Pain_Intensity_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto dói, de 1 a 10`)
};

const fr_fr2_profile_editors_pain_intensity_group = /** @type {(inputs: Profile_Editors_Pain_Intensity_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intensité de la douleur, de 1 à 10`)
};

const de_de2_profile_editors_pain_intensity_group = /** @type {(inputs: Profile_Editors_Pain_Intensity_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie stark es wehtut, 1 bis 10`)
};

const it_it2_profile_editors_pain_intensity_group = /** @type {(inputs: Profile_Editors_Pain_Intensity_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto fa male, da 1 a 10`)
};

/**
* | output |
* | --- |
* | "How much it hurts, 1 to 10" |
*
* @param {Profile_Editors_Pain_Intensity_GroupInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_intensity_group = /** @type {((inputs?: Profile_Editors_Pain_Intensity_GroupInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Intensity_GroupInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_intensity_group(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_intensity_group(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_intensity_group(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_intensity_group(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_intensity_group(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_intensity_group(inputs)
	return en_us2_profile_editors_pain_intensity_group(inputs)
});
export { profile_editors_pain_intensity_group as "profile-editors.pain_intensity_group" }